import { render, staticRenderFns } from "./merchantroleslist.vue?vue&type=template&id=0eed6e74&scoped=true"
import script from "./merchantroleslist.vue?vue&type=script&lang=js"
export * from "./merchantroleslist.vue?vue&type=script&lang=js"
import style0 from "./merchantroleslist.vue?vue&type=style&index=0&id=0eed6e74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eed6e74",
  null
  
)

export default component.exports